// @ts-nocheck
import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import { css } from "styled-components";

export interface SignUpSignInLinkStyles {
    container?: InjectableCss;
    promptText?: TypographyPresentationProps;
    signInLink?: LinkPresentationProps;
}

export const signUpSignInLinkStyles: SignUpSignInLinkStyles = {
    container: {
        css: css`
            display: inline-flex;
            align-items: center;
            gap: 0.25rem;
            flex-wrap: wrap;
        `,
    },
    promptText: {
        forwardAs: "div",
    },
    signInLink: {
        css: css`
            text-transform: uppercase;
            color: ${getColor("primary")};
            font-weight: ${x => x.theme.design.typography.weight.semibold};
        `,
    },
};

const StyledContainer = getStyledWrapper("div");
const styles = signUpSignInLinkStyles;

const SignUpSignInLink: FC<WidgetProps> = () => {
    const signInUrl = useSelector(
        (state: ApplicationState) => getPageLinkByPageType(state, constants.pageType.signIn)?.url,
    );

    if (!signInUrl) {
        return null;
    }

    const goToSignIn = () => {
        window.location.href = signInUrl;
    };

    return (
        <StyledContainer {...styles.container} data-test-selector="signUpSignInLink_container">
            <Typography {...styles.promptText}>{translate("Already have an account?")}</Typography>
            <Link {...styles.signInLink} onClick={goToSignIn} data-test-selector="signUpSignInLink_link">
                {translate("Sign In")}
            </Link>
        </StyledContainer>
    );
};

const widgetModule: WidgetModule = {
    component: SignUpSignInLink,
    definition: {
        allowedContexts: ["SignInPage", "SignInOverlay"],
        displayName: "Sign Up Sign In Link",
        group: "Sign In",
        icon: "LogIn",
        fieldDefinitions: [],
    },
};

export default widgetModule;
